/**
 * Created by Ning Jiang on 11/22/2016.
 */

import {SlotGame} from "@nolimitcity/slot-game/bin/SlotGame";
import {NolimitPlugin} from "@nolimitcity/slot-launcher/bin/NolimitPlugin";
import {LogLevel} from "@nolimitcity/slot-launcher/bin/utils/Logger";
import {GameFlowController} from "@nolimitcity/slot-game/bin/flowcontrol/GameFlowController";
import {FlowState} from "@nolimitcity/slot-game/bin/flowcontrol/FlowState";
import {FlowStatePresentation} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStatePresentation";
import {FontLoader} from "@nolimitcity/slot-launcher/bin/loader/FontLoader";
import {NolimitApplication} from "@nolimitcity/slot-launcher/bin/NolimitApplication";
import {OpenSans} from "@nolimitcity/slot-launcher/bin/loader/font/OpenSans";
import {AssetsConfig} from "@nolimitcity/slot-game/bin/asset/AssetsConfig";
import {AssetLoader} from "@nolimitcity/slot-game/bin/asset/AssetLoader";
import {ResourcesGroupName} from "@nolimitcity/slot-game/bin/asset/ResourcesGroupName";
import {BenjiKIVGameAssets} from "./BenjiKIVGameAssets";
import {BenjiKIVSound} from "./sound/BenjiKIVSound";
import {BenjiKIVBackgroundElements} from "./view/general/BenjiKIVBackgroundElements";
import {BenjiKIVWinPresentation} from "./gameflow/BenjiKIVWinPresentation";
import {BenjiKIVNormalBetPresentation} from "./gameflow/BenjiKIVNormalBetPresentation";
import {BenjiKIVNormalResultPresentation} from "./gameflow/BenjiKIVNormalResultPresentation";
import {BenjiKIVIdleNormalPresentation} from "./gameflow/BenjiKIVIdleNormalPresentation";
import {BenjiKIVFreeSpinIdlePresentation} from "./gameflow/freespin/BenjiKIVFreeSpinIdlePresentation";
import {BenjiKIVModel} from "./BenjiKIVModel";
import {BenjiKIVAllReelsView} from "./view/general/reel/BenjiKIVAllReelsView";
import {BenjiKIVGameMode} from "./server/BenjiKIVGameMode";
import {BenjiKIVRespinTriggeredView} from "./view/general/BenjiKIVRespinTriggeredView";
import {BenjiKIVReSpinIdlePresentation} from "./gameflow/respin/BenjiKIVReSpinIdlePresentation";
import {BenjiKIVEnhancerView} from "./view/general/enhancer/BenjiKIVEnhancerView";
import {MathHelper} from "@nolimitcity/slot-game/bin/utils/MathHelper";
import {BenjiKIVTotalWinView} from "./view/general/BenjiKIVTotalWinView";
import {BenjiKIVBigWinView} from "./view/general/BenjiKIVBigWinView";
import {BenjiKIVFreeSpinIntroView} from "./view/freespin/BenjiKIVFreeSpinIntroView";
import {BenjiKIVFreeSpinWinPresentation} from "./gameflow/freespin/BenjiKIVFreeSpinWinPresentation";
import {BenjiKIVFreeSpinOutroView} from "./view/freespin/BenjiKIVFreeSpinOutroView";
import {BenjiKIVSuperFreeSpinIdlePresentation} from "./gameflow/superfreespin/BenjiKIVSuperFreeSpinIdlePresentation";
import {BenjiKIVSuperFreeSpinWinPresentation} from "./gameflow/superfreespin/BenjiKIVSuperFreeSpinWinPresentation";
import {BenjiKIVSuperFreeSpinIntroView} from "./view/superfreespin/BenjiKIVSuperFreeSpinIntroView";
import {BenjiKIVSuperFreeSpinOutroView} from "./view/superfreespin/BenjiKIVSuperFreeSpinOutroView";
import {BenjiKIVPoolSymbols} from "./pooling/BenjiKIVPoolSymbols";
import {BenjiKIVPoolWildSymbols} from "./pooling/BenjiKIVPoolWildSymbols";
import {BenjiKIVPoolStackedSymbols} from "./pooling/BenjiKIVPoolStackedSymbols";
import {BenjiKIVSymbolsOnTopView} from "./view/general/BenjiKIVSymbolsOnTopView";
import {BenjiKIVInitialWinView} from "./view/general/BenjiKIVInitialWinView";
import {BenjiKIVPoolInitialWinAnimations} from "./pooling/BenjiKIVPoolInitialWinAnimations";
import {BenjiKIVOverlayScatterView} from "./view/general/overlayscatter/BenjiKIVOverlayScatterView";
import {BenjiKIVRespinBetPresentation} from "./gameflow/respin/BenjiKIVRespinBetPresentation";
import {BenjiKIVRespinResultPresentation} from "./gameflow/respin/BenjiKIVRespinResultPresentation";
import {BenjiKIVPoolRingGirls} from "./pooling/BenjiKIVPoolRingGirls";
import {BenjiKIVIntroView} from "./view/general/BenjiKIVIntroView";
import {BenjiKIVFreeSpinBetPresentation} from "./gameflow/freespin/BenjiKIVFreeSpinBetPresentation";
import {BenjiKIVFreeSpinResultPresentation} from "./gameflow/freespin/BenjiKIVFreeSpinResultPresentation";
import {BenjiKIVSuperFSResultPresentation} from "./gameflow/superfreespin/BenjiKIVSuperFSResultPresentation";
import {BenjiKIVSuperFSBetPresentation} from "./gameflow/superfreespin/BenjiKIVSuperFSBetPresentation";
import {BenjiKIVOverlayScatterRunner} from "./presentationrunners/scatter/BenjiKIVOverlayScatterRunner";
import {BenjiKIVPoolOverlayScatter} from "./pooling/BenjiKIVPoolOverlayScatter";
import {BenjiKIVSFSMoreScatterView} from "./view/superfreespin/BenjiKIVSFSMoreScatterView";
import {BenjiKIVXBetView} from "./view/general/BenjiKIVXBetView";
import {BenjiKIVBoostedOverlayScatterRunner} from "./presentationrunners/scatter/BenjiKIVBoostedOverlayScatterRunner";
import {BenjiKIVMaxWinView} from "./view/general/BenjiKIVMaxWinView";
import {BenjiKIVNoWinView} from "./view/general/BenjiKIVNoWinView";
import {BenjiKIVPoolScatterSymbols} from "./pooling/BenjiKIVPoolScatterSymbols";
import {BenjiKIVMidSymController} from "./reels/BenjiKIVMidSymController";
import {BenjiKIVIndividualWinView} from "./view/general/BenjiKIVIndividualWinView";
import {BenjiKIVPoolIndividualWinAnimations} from "./pooling/BenjiKIVPoolIndividualWinAnimation";
import {BenjiKIVWinWaysView} from "./view/general/BenjiKIVWinWaysView";
import {BenjiKIVPoolSplitSymbolAnimations} from "./pooling/BenjiKIVPoolSplitSymbolAnimations";
import {BenjiKIVSymbolSplitView} from "./view/general/BenjiKIVSymbolSplitView";
import {BenjiKIVMultiplierCountUpView} from "./view/general/BenjiKIVMultiplierCountUpView";
import {ParticlesManager} from "./components/particles/ParticlesManager";
import {BenjiKIVAnticipationView} from "./view/BenjiKIVAnticipationView";
import {APIEvent} from "@nolimitcity/slot-launcher/bin/interfaces/APIEventSystem";
import {BenjiKIVIntroConfig} from "./intro/BenjiKIVIntroConfig";
import {BetFeature} from "@nolimitcity/slot-launcher/bin/plugins/apiplugin/bethandler/BetFeatureController";
import {FeatureBetLevelsData} from "@nolimitcity/slot-launcher/bin/plugins/apiplugin/BetLevelHandler";
import {BenjiKIVPoolFastWinWays} from "./pooling/BenjiKIVPoolFastWinWays";
import {BenjiKIVFastToggleWinWaysView} from "./view/general/BenjiKIVFastToggleWinWaysView";
import {Skinner} from "@nolimitcity/slot-launcher/bin/utils/Skinner";

export class BenjiKIV extends SlotGame {
    public static introConfigInstance: BenjiKIVIntroConfig;

    public static isActionSpinsActive: boolean = false;
    public static model: BenjiKIVModel;
    public static assetLoader: AssetLoader;
    public static soundPlayer: BenjiKIVSound;
    public static backgroundElements: BenjiKIVBackgroundElements;
    public static gameFlowController: GameFlowController;
    public static symbolsPool: BenjiKIVPoolSymbols;
    public static wildSymbolsPool: BenjiKIVPoolWildSymbols;
    public static stackedSymbolsPool: BenjiKIVPoolStackedSymbols;
    public static ringGirlsPool: BenjiKIVPoolRingGirls;
    public static overlayScatterPool: BenjiKIVPoolOverlayScatter;
    public static scatterPool: BenjiKIVPoolScatterSymbols;
    public static fastWinWaysPool: BenjiKIVPoolFastWinWays;
    public static allReelView: BenjiKIVAllReelsView;
    public static respinTriggeredView: BenjiKIVRespinTriggeredView;
    public static enhancerView: BenjiKIVEnhancerView;
    public static totalWinView: BenjiKIVTotalWinView;
    public static bigWinView: BenjiKIVBigWinView;
    public static fsIntroView: BenjiKIVFreeSpinIntroView;
    public static fsOutroView: BenjiKIVFreeSpinOutroView;
    public static superFsIntroView: BenjiKIVSuperFreeSpinIntroView;
    public static superFsOutroView: BenjiKIVSuperFreeSpinOutroView;
    public static symbolsOnTopView: BenjiKIVSymbolsOnTopView;
    public static initialWinView: BenjiKIVInitialWinView;
    public static initialWinSpinesPool: BenjiKIVPoolInitialWinAnimations;
    public static overlayScatterView: BenjiKIVOverlayScatterView;
    public static sfsMoreScatterView: BenjiKIVSFSMoreScatterView;
    public static maxWinView: BenjiKIVMaxWinView;
    public static introView: BenjiKIVIntroView;
    public static xBetView: BenjiKIVXBetView;
    public static noWinView: BenjiKIVNoWinView;
    public static splitSymbolView: BenjiKIVSymbolSplitView;
    public static anticipationView: BenjiKIVAnticipationView;

    public static midSymController: BenjiKIVMidSymController;
    public static splitSymbolSpinesPool: BenjiKIVPoolSplitSymbolAnimations;

    public static buyFeatureName: string = "";

    // #260
    public static boostBet1AllowedBetLevel: number = -1;
    public static boostBet2AllowedBetLevel: number = -1;
    public static betOnInit: number = 0; // #260 -> 8th feb, 2024 comments.

    public static normalResult: BenjiKIVNormalResultPresentation;
    public static respinResult: BenjiKIVRespinResultPresentation;
    public static freeSpinResult: BenjiKIVFreeSpinResultPresentation;
    public static superFSResult: BenjiKIVSuperFSResultPresentation;

    public static normalBoostedOverlayRunner: BenjiKIVBoostedOverlayScatterRunner;
    public static respinOverlayRunner: BenjiKIVOverlayScatterRunner;
    public static freeSpinOverlayRunner: BenjiKIVOverlayScatterRunner;
    public static superFSOverlayRunner: BenjiKIVOverlayScatterRunner;

    public static individualWin: BenjiKIVIndividualWinView;
    public static individualWinSpinesPool: BenjiKIVPoolIndividualWinAnimations;
    public static winWays: BenjiKIVWinWaysView;
    public static fastWinWays: BenjiKIVFastToggleWinWaysView;
    public static multiplierCountUp: BenjiKIVMultiplierCountUpView;
    public static particleManager: ParticlesManager;
    public static bigWinCountUp: PIXI.Container;

    public static xBetRedAllowed: boolean = true; // https://github.com/nolimitcity/QA/issues/587

    private skinner:Skinner;
    constructor() {
        super();
        const validSkins:string[] = [
            "sweep"
        ]
        this.skinner = new Skinner(validSkins);
    }

    public static isWinBelowPlayedBetValue(): boolean {
        if (!BenjiKIV.apiPlugin.gameClientConfiguration.belowStakeWinRestriction) {
            return false;
        }

        let playedBetValue: number = BenjiKIV.model.gameData?.playedBetValue || parseFloat(BenjiKIV.apiPlugin.freeBets.hasFreeBets() ? BenjiKIV.apiPlugin.freeBets.getBet() : BenjiKIV.apiPlugin.betLevel.getLevel());

        //If xbet is on, played bet value should be the xbet cost
        if (BenjiKIV.apiPlugin.freeBets.hasFreeBets() == false && BenjiKIV.apiPlugin.betHandler.betBoost) {
            playedBetValue = BenjiKIV.apiPlugin.betHandler.betBoost?.calculatedPrice;
        }

        return (BenjiKIV.model.gameData?.totalSpinWinnings / playedBetValue) <= 1;
    }

    public static isWinBelowStake(): boolean {
        return BenjiKIV.apiPlugin.gameClientConfiguration.belowStakeWinRestriction && (this.model.accumulatedRoundWin <= this.getBuyFeaturePrice());
    }

    public static getBuyFeaturePrice(): number {
        const betLevel: string = BenjiKIV.apiPlugin.freeBets.hasFreeBets() ? BenjiKIV.apiPlugin.freeBets.getBet() : BenjiKIV.apiPlugin.betLevel.getLevel();
        let price: number = BenjiKIV.model.gameData?.playedBetValue || parseFloat(betLevel);
        if (this.buyFeatureName.length > 0) {
            for (let index: number = 0; index < BenjiKIV.model.featureBuyTimesBetValue.length; index++) {
                if (BenjiKIV.model.initData.featureBuyTimesBetValue[index].name === this.buyFeatureName) {
                    price *= BenjiKIV.model.initData.featureBuyTimesBetValue[index].price;
                    break;
                }
            }
        }
        return MathHelper.ceilToDecimals(price, 2);
    }

    public getNoWinGameData(): any {
        return {
            "reels": [
                [
                    "L1",
                    "M1",
                    "L1",
                    "L2",
                    "L4"
                ],
                [
                    "L2",
                    "M2",
                    "M2",
                    "M2",
                    "L4"
                ],
                [
                    "L4",
                    "M3",
                    "L4",
                    "L4",
                    "L1"
                ],
                [
                    "L1",
                    "L1",
                    "L1",
                    "L2",
                    "L5"
                ],
                [
                    "L5",
                    "M1",
                    "M1",
                    "M1",
                    "L1"
                ]
            ],
            "evaluatedArea": [
                [
                    "M1",
                    "L1",
                    "L2"
                ],
                [
                    "M2",
                    "M2",
                    "M2"
                ],
                [
                    "M3",
                    "L4",
                    "L4"
                ],
                [
                    "L1",
                    "L1",
                    "L2"
                ],
                [
                    "M1",
                    "M1",
                    "M1"
                ]
            ],
            "betWayWins": [],
            "totalSpinWinnings": 0,
            "accumulatedRoundWin": 0,
            "playedBetValue": 1,
            "mode": "NORMAL",
            "nextMode": "NORMAL",
            "numberOfFreespinsPlayed": 0,
            "freespinsLeft": 0,
            "freespinTriggeredThisSpin": false,
            "symbolSizes": [
                [
                    1,
                    1,
                    1
                ],
                [
                    1,
                    1,
                    1
                ],
                [
                    1,
                    1,
                    1
                ],
                [
                    1,
                    1,
                    1
                ],
                [
                    1,
                    1,
                    1
                ]
            ],
            "wasFeatureBuy": false,
            "currentMultiplier": 1,
            "brokeTheBank": false,
            "enhancedBet": 0,
            "scatterReels": [
                false,
                false,
                false,
                false,
                false
            ],
            "playerInteraction": {},
            "collectedScatters": 0,
            "multiplierScatters": [
                2,
                3,
                4,
                5,
                6
            ],
            "overlayScatter": []
        }
    }

    // https://github.com/nolimitcity/QA/issues/587
    private paytable:string = require("../../nolimit/screens/paytable.mustache");
    public getPaytable(): Promise<string> {
        return new Promise((resolve, reject) => {
            const data = {
                skinPath: "screens/images/"
            };

            if (this.skinner.skinId != undefined) {
                data.skinPath = `../resources/images/${this.skinner.skinId}/`;
            }
            let paytableString: string = (<any>this.paytable).text;
            paytableString = paytableString.replace(/{{skinPath}}/g, data.skinPath);
            paytableString = paytableString.replace(new RegExp("#xBetRedAllowed", "g"), (BenjiKIV.xBetRedAllowed ? "" : "xBetRedNotAllowed"));
            resolve(paytableString);
        });
    }

    // https://github.com/nolimitcity/QA/issues/587
    public getGameRules(): Promise<string> {
        return super.getGameRules().then((value: string) => {
            value = value.replace(new RegExp("#xBetRedAllowed", "g"), (BenjiKIV.xBetRedAllowed ? "" : "xBetRedNotAllowed"));

            return value;
        });
    }

    public init(): Promise<NolimitPlugin> {
        return super.init().then((value: NolimitPlugin) => {
            //ActionSpinHandler.addEventListener();
            BenjiKIV.model = new BenjiKIVModel(SlotGame.apiPlugin, true);
            BenjiKIV.gameFlowController = new GameFlowController(SlotGame.apiPlugin, BenjiKIV.model);
            BenjiKIV.gameFlowController.flowStateLogger.level = LogLevel.DEV;

            // #260
            BenjiKIV.apiPlugin.events.once(APIEvent.FEATURE_BET_LEVELS, (data: FeatureBetLevelsData) => {
                if (data["BOOSTED_BET"]) {
                    BenjiKIV.boostBet1AllowedBetLevel = parseFloat(data["BOOSTED_BET"][data["BOOSTED_BET"].length - 1]);
                }

                if (data["BOOSTED_BET_2"]) {
                    BenjiKIV.boostBet2AllowedBetLevel = parseFloat(data["BOOSTED_BET_2"][data["BOOSTED_BET_2"].length - 1]);
                }
            });

            // #260 -> 8th feb, 2024 comments. Want to listen this only once.
            BenjiKIV.apiPlugin.events.once(APIEvent.CURRENT_BET, (currentBet: string) => {
                BenjiKIV.betOnInit = parseFloat(currentBet);
            });

            // https://github.com/nolimitcity/QA/issues/587
            BenjiKIV.apiPlugin.events.once(APIEvent.ALLOWED_GAME_FEATURES, (data: any) => {
                data = Array.isArray(data) ? data : data.allowedGameFeatures;

                BenjiKIV.xBetRedAllowed = (data.includes(BenjiKIVXBetView.BOOST_BET_2));

                // #278
                BenjiKIV.introConfigInstance.onXBetRedDecided();
            });


            BenjiKIV.symbolsPool = new BenjiKIVPoolSymbols();
            BenjiKIV.wildSymbolsPool = new BenjiKIVPoolWildSymbols();
            BenjiKIV.stackedSymbolsPool = new BenjiKIVPoolStackedSymbols();
            BenjiKIV.initialWinSpinesPool = new BenjiKIVPoolInitialWinAnimations();
            BenjiKIV.ringGirlsPool = new BenjiKIVPoolRingGirls();
            BenjiKIV.overlayScatterPool = new BenjiKIVPoolOverlayScatter();
            BenjiKIV.scatterPool = new BenjiKIVPoolScatterSymbols();
            BenjiKIV.individualWinSpinesPool = new BenjiKIVPoolIndividualWinAnimations();
            BenjiKIV.splitSymbolSpinesPool = new BenjiKIVPoolSplitSymbolAnimations();

            const winPres: BenjiKIVWinPresentation = new BenjiKIVWinPresentation();
            const idleNormal: BenjiKIVIdleNormalPresentation = new BenjiKIVIdleNormalPresentation();
            const reelStart: BenjiKIVNormalBetPresentation = new BenjiKIVNormalBetPresentation();
            const reelStartRespin: BenjiKIVRespinBetPresentation = new BenjiKIVRespinBetPresentation();
            BenjiKIV.normalResult = new BenjiKIVNormalResultPresentation();
            BenjiKIV.respinResult = new BenjiKIVRespinResultPresentation();

            const reSpinIdle: BenjiKIVReSpinIdlePresentation = new BenjiKIVReSpinIdlePresentation();

            //FreeSpin
            const freeSpinIdle: BenjiKIVFreeSpinIdlePresentation = new BenjiKIVFreeSpinIdlePresentation();
            const freeSpinWin: BenjiKIVFreeSpinWinPresentation = new BenjiKIVFreeSpinWinPresentation();
            const freeSpinBet: BenjiKIVFreeSpinBetPresentation = new BenjiKIVFreeSpinBetPresentation();
            BenjiKIV.freeSpinResult = new BenjiKIVFreeSpinResultPresentation();

            //Super FreeSpin
            const superFreeSpinIdle: BenjiKIVSuperFreeSpinIdlePresentation = new BenjiKIVSuperFreeSpinIdlePresentation();
            const superFreeSpinWin: BenjiKIVSuperFreeSpinWinPresentation = new BenjiKIVSuperFreeSpinWinPresentation();
            const superFSSpinBet: BenjiKIVSuperFSBetPresentation = new BenjiKIVSuperFSBetPresentation();
            BenjiKIV.superFSResult = new BenjiKIVSuperFSResultPresentation();

            BenjiKIV.gameFlowController.addGameModeFlowStatePresentationMap(BenjiKIVGameMode.NORMAL, new Map<FlowState, FlowStatePresentation>([
                [FlowState.IDLE, idleNormal],
                [FlowState.BET, reelStart],
                [FlowState.RESULT, BenjiKIV.normalResult],
                [FlowState.WIN, winPres]
            ]));
            BenjiKIV.gameFlowController.addGameModeFlowStatePresentationMap(BenjiKIVGameMode.NORMAL_EXTRA_SPIN, new Map<FlowState, FlowStatePresentation>([
                [FlowState.IDLE, reSpinIdle],
                [FlowState.BET, reelStartRespin],
                [FlowState.RESULT, BenjiKIV.respinResult],
                [FlowState.WIN, winPres]
            ]));
            BenjiKIV.gameFlowController.addGameModeFlowStatePresentationMap(BenjiKIVGameMode.FREESPIN, new Map<FlowState, FlowStatePresentation>([
                [FlowState.IDLE, freeSpinIdle],
                [FlowState.BET, freeSpinBet],
                [FlowState.RESULT, BenjiKIV.freeSpinResult],
                [FlowState.WIN, freeSpinWin]
            ]));
            BenjiKIV.gameFlowController.addGameModeFlowStatePresentationMap(BenjiKIVGameMode.SUPER_FREESPIN, new Map<FlowState, FlowStatePresentation>([
                [FlowState.IDLE, superFreeSpinIdle],
                [FlowState.BET, superFSSpinBet],
                [FlowState.RESULT, BenjiKIV.superFSResult],
                [FlowState.WIN, superFreeSpinWin]
            ]));

            //Making sure that skinID is set based  on "replaceWordFree" gcc.
            if (SlotGame.apiPlugin.gameClientConfiguration.isSet){
                if (SlotGame.apiPlugin.gameClientConfiguration.sweepGfx){
                    this.skinner.skinId = "sweep";
                }
            }
            else {
                SlotGame.apiPlugin.events.on(APIEvent.GAME_CLIENT_CONFIGURATION_APPLIED,()=>{
                    if (SlotGame.apiPlugin.gameClientConfiguration.sweepGfx){
                        this.skinner.skinId = "sweep";
                    }
                })
            }
            return value;
        });
    }

    public getReady(): Promise<NolimitPlugin> {
        //Show intro and load game assets
        return super.getReady().then((value: NolimitPlugin) => {

            const fontLoader = new FontLoader(NolimitApplication.resourcePath);
            fontLoader.add(OpenSans.ITALIC_600);
            fontLoader.add(OpenSans.NORMAL_300);
            fontLoader.add(OpenSans.NORMAL_400);
            fontLoader.add(OpenSans.NORMAL_700);

            AssetsConfig.addToAssetsConfig(BenjiKIVGameAssets.RESOURCES_GROUPS);
            BenjiKIV.assetLoader = new AssetLoader(BenjiKIV.apiPlugin, NolimitApplication.resourcePath + "/resources/");
            const allPromises = [fontLoader.load(), BenjiKIV.assetLoader.load(ResourcesGroupName.MAIN)]
            if (this.skinner.skinId != undefined) {
                const replaceMap:Map<string, string> = new Map();
                //Bonus
                replaceMap.set("pageImage_7", "pageImage_7.jpg")
                replaceMap.set("pageImage_8", "pageImage_8.jpg")
                replaceMap.set("feature1", "intro_feature1.png")
                replaceMap.set("BOOSTED_BET", "BOOSTED_BET.png");
                replaceMap.set("BOOSTED_BET_2", "BOOSTED_BET_2.png");
                allPromises.push(this.skinner.loadSkin(replaceMap));
            }
            const promises = Promise.all(allPromises);

            return promises.then((values: any) => {

                this.createViewsAndComponents();
                BenjiKIV.soundPlayer.switchMusic(BenjiKIV.model.data.mode);

                return value;
            });
        });
    }

    public getReadyToStart(): Promise<NolimitPlugin> {
        //Game assets loaded, waiting for user to start game.
        return super.getReadyToStart().then((value: NolimitPlugin) => {
            if (BenjiKIV.apiPlugin.gameClientConfiguration.displayIndividualWinsInGame == true) {
                BenjiKIV.fastWinWaysPool = new BenjiKIVPoolFastWinWays();
                BenjiKIV.fastWinWaysPool.init();
            }
            return value;
        });
    }

    public start(): Promise<NolimitPlugin> {
        //User has pressed continue and the game starts.
        return super.start().then((value: NolimitPlugin) => {
            BenjiKIV.gameFlowController.start();
            if (!BenjiKIV.model.isRestore && !BenjiKIV.apiPlugin.isReplay) {
                BenjiKIV.introView.playRandomIntro();
            }

            BenjiKIV.apiPlugin.events.on(APIEvent.SELECTED_FEATURE_BET_CHANGED, (data: any) => {
                const featureBetData: BetFeature | undefined = BenjiKIV.apiPlugin.betFeatureController.getActiveBetFeature();
                if (featureBetData) {
                    if (featureBetData?.name == BenjiKIVXBetView.BOOST_BET_1) {
                        BenjiKIV.xBetView.level01Toggle();
                    } else if (featureBetData?.name == BenjiKIVXBetView.BOOST_BET_2) {
                        BenjiKIV.xBetView.level02Toggle();
                    } else if (featureBetData?.name !== BenjiKIVXBetView.BOOST_BET_2 && featureBetData?.name !== BenjiKIVXBetView.BOOST_BET_1) {
                        BenjiKIV.xBetView.turnOffBoost(false);
                        BenjiKIV.apiPlugin.betFeatureController.setActiveBetFeature(featureBetData.name);
                    }
                } else {
                    BenjiKIV.xBetView.turnOffBoost(false);
                }
            });

            return value;
        });
    }

    private createViewsAndComponents(): void {
        //Non views
        BenjiKIV.soundPlayer = new BenjiKIVSound();

        BenjiKIV.symbolsPool.init();
        BenjiKIV.wildSymbolsPool.init();
        BenjiKIV.stackedSymbolsPool.init();
        BenjiKIV.initialWinSpinesPool.init();
        BenjiKIV.ringGirlsPool.init();
        BenjiKIV.overlayScatterPool.init();
        BenjiKIV.scatterPool.init();
        BenjiKIV.individualWinSpinesPool.init();
        BenjiKIV.splitSymbolSpinesPool.init();
        BenjiKIV.particleManager = new ParticlesManager();

        //Static views
        BenjiKIV.backgroundElements = new BenjiKIVBackgroundElements();
        BenjiKIV.backgroundElements.setMode(BenjiKIV.model.data.nextMode);
        BenjiKIV.allReelView = new BenjiKIVAllReelsView();
        BenjiKIV.respinTriggeredView = new BenjiKIVRespinTriggeredView();
        BenjiKIV.totalWinView = new BenjiKIVTotalWinView();
        BenjiKIV.bigWinCountUp = new PIXI.Container();
        BenjiKIV.bigWinView = new BenjiKIVBigWinView();
        BenjiKIV.fsIntroView = new BenjiKIVFreeSpinIntroView();
        BenjiKIV.fsOutroView = new BenjiKIVFreeSpinOutroView();
        BenjiKIV.superFsIntroView = new BenjiKIVSuperFreeSpinIntroView();
        BenjiKIV.superFsOutroView = new BenjiKIVSuperFreeSpinOutroView();
        BenjiKIV.symbolsOnTopView = new BenjiKIVSymbolsOnTopView();
        BenjiKIV.overlayScatterView = new BenjiKIVOverlayScatterView();
        BenjiKIV.sfsMoreScatterView = new BenjiKIVSFSMoreScatterView();
        BenjiKIV.xBetView = new BenjiKIVXBetView();
        BenjiKIV.noWinView = new BenjiKIVNoWinView();
        BenjiKIV.anticipationView = new BenjiKIVAnticipationView();
        BenjiKIV.splitSymbolView = new BenjiKIVSymbolSplitView();
        BenjiKIV.enhancerView = new BenjiKIVEnhancerView();
        BenjiKIV.introView = new BenjiKIVIntroView();
        BenjiKIV.maxWinView = new BenjiKIVMaxWinView();

        BenjiKIV.midSymController = new BenjiKIVMidSymController();

        BenjiKIV.individualWin = new BenjiKIVIndividualWinView();
        BenjiKIV.initialWinView = new BenjiKIVInitialWinView();
        BenjiKIV.winWays = new BenjiKIVWinWaysView();
        BenjiKIV.fastWinWays = new BenjiKIVFastToggleWinWaysView();
        BenjiKIV.multiplierCountUp = new BenjiKIVMultiplierCountUpView();

        BenjiKIV.apiPlugin.events.on(APIEvent.ACTION_SPINS_IS_ACTIVE, (data: any): void => {
            if (data === true) {
                BenjiKIV.isActionSpinsActive = true;
                BenjiKIV.individualWin.stop();
                BenjiKIV.enhancerView.reset();
            } else {
                BenjiKIV.isActionSpinsActive = false;
            }
        });


        NolimitApplication.addLayerAt(BenjiKIV.maxWinView.name, BenjiKIV.maxWinView, 0);
        NolimitApplication.addLayerAt(BenjiKIV.superFsIntroView.name, BenjiKIV.superFsIntroView, 0);
        NolimitApplication.addLayerAt(BenjiKIV.superFsOutroView.name, BenjiKIV.superFsOutroView, 0);
        NolimitApplication.addLayerAt(BenjiKIV.sfsMoreScatterView.name, BenjiKIV.sfsMoreScatterView, 0);
        NolimitApplication.addLayerAt(BenjiKIV.fsIntroView.name, BenjiKIV.fsIntroView, 0);
        NolimitApplication.addLayerAt(BenjiKIV.fsOutroView.name, BenjiKIV.fsOutroView, 0);
        NolimitApplication.addLayerAt(BenjiKIV.introView.name, BenjiKIV.introView, 0);
        NolimitApplication.addLayerAt(BenjiKIV.multiplierCountUp.name, BenjiKIV.multiplierCountUp, 0);
        NolimitApplication.addLayerAt(BenjiKIV.winWays.name, BenjiKIV.winWays, 0);
        NolimitApplication.addLayerAt(BenjiKIV.fastWinWays.name, BenjiKIV.fastWinWays, 0);
        NolimitApplication.addLayerAt("BenjiKIVBigWinCountUp", BenjiKIV.bigWinCountUp, 0);
        NolimitApplication.addLayerAt(BenjiKIV.noWinView.name, BenjiKIV.noWinView, 0);
        NolimitApplication.addLayerAt(BenjiKIV.bigWinView.name, BenjiKIV.bigWinView, 0);
        NolimitApplication.addLayerAt(BenjiKIV.totalWinView.name, BenjiKIV.totalWinView, 0);
        NolimitApplication.addLayerAt(BenjiKIV.anticipationView.name, BenjiKIV.anticipationView, 0);
        NolimitApplication.addLayerAt(BenjiKIV.splitSymbolView.name, BenjiKIV.splitSymbolView, 0);
        NolimitApplication.addLayerAt(BenjiKIV.symbolsOnTopView.name, BenjiKIV.symbolsOnTopView, 0);
        NolimitApplication.addLayerAt(BenjiKIV.individualWin.name, BenjiKIV.individualWin, 0);
        NolimitApplication.addLayerAt(BenjiKIV.initialWinView.name, BenjiKIV.initialWinView, 0);
        NolimitApplication.addLayerAt(BenjiKIV.overlayScatterView.name, BenjiKIV.overlayScatterView, 0);
        NolimitApplication.addLayerAt(BenjiKIV.xBetView.name, BenjiKIV.xBetView, 0);
        NolimitApplication.addLayerAt(BenjiKIV.respinTriggeredView.name, BenjiKIV.respinTriggeredView, 0);
        NolimitApplication.addLayerAt(BenjiKIV.enhancerView.name, BenjiKIV.enhancerView, 0);
        NolimitApplication.addLayerAt(BenjiKIV.allReelView.name, BenjiKIV.allReelView, 0);
        NolimitApplication.addLayerAt(BenjiKIV.backgroundElements.name, BenjiKIV.backgroundElements, 0);
    }
}